import ResultPanel from './ResultPanel';
import { useImport } from './useImport';
import IntegrationInfo from './IntegrationInfo';
import { Section, Button, Loading } from '../../components';
import { Input, Dropdown, Form, FormItem } from '../../components';
import type { FormType } from './useImport';
import type { DuplicateStrategyType } from '../../api';

const ON_DUPLICATE_OPTIONS: OptionType<DuplicateStrategyType>[] = [
  { value: 'skip', label: 'Skip duplicates' },
  { value: 'error', label: 'Error on duplicates' },
  { value: 'override', label: 'Override duplicates' },
];

const ContactImport = () => {
  const {
    campaigns,

    campaignId,

    form,
    setForm,

    jsonText,
    setJsonText,

    error,
    result,
    loading,
    fileInputRef,
    selectedFile,

    setJsonError,
    handleCsvUpload,
    handleFileChange,
    handleJsonImport,
  } = useImport();

  return (
    <div className="flex flex-col gap-y-xl">
      <div className="flex flex-row flex-wrap gap-md">
        <Form initialValue={form} onChange={setForm}>
          <FormItem<FormType> name="campaignId" label="" required>
            <Dropdown options={campaigns} placeholder="Select campaign" />
          </FormItem>
          <FormItem<FormType> name="duplicateStrategy" label="" required>
            <Dropdown options={ON_DUPLICATE_OPTIONS} />
          </FormItem>
        </Form>
      </div>

      <Section
        title="CSV Upload"
        subtitle={
          <>
            <span>Upload a CSV file with columns: </span>
            <code className="bg-active px-xs rounded-sm text-text">
              email
            </code>,{' '}
            <code className="bg-active px-xs rounded-sm text-text">phone</code>,{' '}
            <code className="bg-active px-xs rounded-sm text-text">
              first_name
            </code>
            ,{' '}
            <code className="bg-active px-xs rounded-sm text-text">
              last_name
            </code>
            ,{' '}
            <code className="bg-active px-xs rounded-sm text-text">
              company
            </code>
            ,{' '}
            <code className="bg-active px-xs rounded-sm text-text">
              description
            </code>
          </>
        }
      >
        <div className="flex flex-row flex-wrap gap-md items-center flex-grow">
          <input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            onChange={handleFileChange}
            className="text-small text-text file:mr-md file:py-sm file:px-lg file:rounded-sm file:border file:border-active file:bg-content file:text-text file:font-medium file:cursor-pointer hover:file:bg-active"
          />
          <Button
            type="primary"
            loading={loading}
            disabled={!selectedFile || !campaignId}
            onClick={handleCsvUpload}
          >
            Upload CSV
          </Button>
        </div>
        {selectedFile && (
          <span className="text-small text-textLight">
            Selected: {selectedFile.name} (
            {(selectedFile.size / 1024).toFixed(1)} KB)
          </span>
        )}
      </Section>

      <Section
        title="JSON Import"
        subtitle={
          <>
            Paste the full JSON payload below. Must contain a{' '}
            <code className="bg-active text-text px-xs rounded-sm">
              contacts
            </code>{' '}
            array.
          </>
        }
      >
        <Input
          multiline
          value={jsonText}
          onChange={value => {
            setJsonText(value);
            setJsonError(null);
          }}
          rows={16}
        />
        {error && <span className="text-small text-danger">{error}</span>}
        <div className="flex flex-row gap-md">
          <Button
            type="primary"
            loading={loading}
            disabled={!campaignId || !jsonText.trim()}
            onClick={handleJsonImport}
          >
            Import Contacts
          </Button>
        </div>
      </Section>

      {campaignId && <IntegrationInfo campaignId={campaignId} />}

      {loading && <Loading />}
      {result && <ResultPanel result={result} />}
    </div>
  );
};

export default ContactImport;
